import { render, staticRenderFns } from "./StorageShippingUnits.vue?vue&type=template&id=e0b6cafe&"
import script from "./StorageShippingUnits.vue?vue&type=script&lang=ts&"
export * from "./StorageShippingUnits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports